import { useEffect } from 'react';

/**
 * Hook para ajustar el tamaño de fuente base según el ancho de la pantalla
 * Proporción: 8px para 1920px de ancho
 * 
 * @param {number} baseSize - Tamaño base en píxeles (por defecto 8)
 * @param {number} baseWidth - Ancho base de referencia en píxeles (por defecto 1920)
 */
export const useResponsiveFontSize = (baseSize = 8, baseWidth = 1920) => {
  useEffect(() => {
    const updateFontSize = () => {
      const currentWidth = window.innerWidth;
      // Calcular el tamaño de fuente proporcional
      const fontSize = Math.ceil((currentWidth / baseWidth) * baseSize);
      
      // Aplicar el tamaño de fuente al elemento html
      document.documentElement.style.fontSize = `${fontSize}px`;
    };

    // Ejecutar al montar
    updateFontSize();

    // Actualizar en resize
    window.addEventListener('resize', updateFontSize);

    // Cleanup
    return () => {
      window.removeEventListener('resize', updateFontSize);
    };
  }, [baseSize, baseWidth]);
};

export default useResponsiveFontSize;
